import { render, staticRenderFns } from "./fundsTransfer.vue?vue&type=template&id=06c1b3df&"
import script from "./fundsTransfer.vue?vue&type=script&lang=js&"
export * from "./fundsTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports